import React from 'react';
import './Clientes-Modal.css';

import Video from './assets/HumbertoParada/Video.mp4';

const HumbertoParada = () => {
    return (
        <div className='container'>
            <h2> 
                
                ✅ Proyecto: Residencial Humberto Parada🌞✨
            </h2>
            <video controls>
                <source src={Video} type="video/mp4" />
                Tu navegador no soporta la reproducción de video.
            </video>
            <p>
               

<span className="highlight"> Energía solar para un hogar más eficiente, seguro, sostenible y con mayor valorización.</span><br/>
 

<br/> En este proyecto residencial, instalamos un sistema solar fotovoltaico conectado a la red con una capacidad de 2.52 kWp, conformado por 4 paneles solares de alta eficiencia y un inversor centralizado de 3 kW, una tecnología estable, robusta y confiable para cubrir las necesidades eléctricas del hogar.

<br/><br/>Gracias a esta solución, el sistema gestiona eficientemente las cargas residenciales <span className="highlight">iluminación, electrodomésticos, equipos de uso continuo </span> reduciendo la energía tomada de la red y mejorando la autonomía del hogar.

<br/><br/>Los objetivos de este proyecto fueron:<br/>

<br/>✔ Reducir el costo mensual por consumo eléctrico.
<br/>✔ Implementar una alternativa sostenible que contribuya al cuidado ambiental.
<br/>✔ Asegurar energía confiable para las actividades diarias del hogar.
<br/>✔ valorización del inmueble.

<br/><br/>Hoy, la vivienda Humberto Parada produce de su energía limpia, logrando un ahorro constante en su factura eléctrica y aumentando el valor de la propiedad mediante una tecnología moderna y duradera.

<br/><br/>Esta instalación convierte la vivienda en un ejemplo de responsabilidad energética, demostrando que adoptar soluciones solares es una decisión inteligente y sostenible.

<br/><br/><span className="highlight">Este proyecto cuenta con el acompañamiento de IPSUM Ingeniería e Innovación, ofreciendo: </span>

<br/><br/>🔧 Soporte técnico y mantenimiento preventivo.
<br/>🔧 Monitoreo del sistema para garantizar máxima eficiencia.
<br/>🔧 Instalación estructural segura que prolonga la vida útil del sistema y facilita su mantenimiento.
<br/>🔧 Capacitación al usuario en el manejo de la aplicación de monitoreo.
<br/>🔧 Acompañamiento presencial de nuestros ingenieros durante y después de la instalación.


<br/><br/>Una decisión que une ahorro, sostenibilidad y tranquilidad para el hogar.
 
  </p>
        </div>
    );
}

export default HumbertoParada;
